import React from 'react';

import { PaymentMethodType, PaymentMethods } from 'Jsx/CheckoutV4/types';

import { isCardPaymentMethod } from 'Jsx/CheckoutV4/utils';

import Method from './Method';

const PaymentMethodsTab: React.FC<{
  selectedPaymentMethod?: PaymentMethodType;
  paymentMethods: PaymentMethods;
  selectAnotherPaymentMethod: (value: PaymentMethodType) => void;
}> = ({
  selectedPaymentMethod,
  paymentMethods,
  selectAnotherPaymentMethod,
}) => (
  <div>
    {paymentMethods &&
      Object.keys(paymentMethods).map(method => {
        if (paymentMethods?.[method]?.paymentGatewayId) {
          return (
            <div key={paymentMethods[method]?.title} className="mb-4">
              <Method
                paymentGatewayId={
                  paymentMethods?.[method]?.paymentGatewayId || 0
                }
                title={paymentMethods?.[method]?.title || ''}
                extraCommission={paymentMethods?.[method]?.extraCommission}
                logoMiniatureUrl={paymentMethods?.[method]?.logoMiniatureUrl}
                maxAmount={paymentMethods?.[method]?.maxAmount}
                offlineLabel={paymentMethods?.[method]?.offlineLabel}
                slug={paymentMethods?.[method]?.slug}
                text={paymentMethods?.[method]?.text}
                isMethodWithText={paymentMethods?.[method]?.isMethodWithText}
                isSelected={
                  selectedPaymentMethod?.title === paymentMethods[method]?.title
                }
                selectAnotherPaymentMethod={selectAnotherPaymentMethod}
                logoUrl={paymentMethods?.[method]?.logoUrl}
                isCard={isCardPaymentMethod(
                  paymentMethods?.[method]?.title as string,
                )}
              />
            </div>
          );
        }
        return <span key="noPaymentMethods" />;
      })}
  </div>
);

export default PaymentMethodsTab;
